var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"store-landing-featured-wrapper"},[_c('div',{staticClass:"container xl"},[_c('div',{staticClass:"featured-cat-heading-withnav relative"},[_c('div',{staticClass:"featured-heading"},[_c('h2',{staticClass:"is-size-4 mb-3"},[_c('span',[_vm._v(_vm._s(_vm.title))])])]),_c('a',{class:'nav-button button-prev bg-secondary arrow-prev'+_vm.id,on:{"click":_vm.prev}},[_c('img',{attrs:{"src":require("@/assets/img/scroll-top.svg")}})]),_c('a',{class:'nav-button button-next bg-secondary arrow-next'+_vm.id,on:{"click":_vm.next}},[_c('img',{attrs:{"src":require("@/assets/img/scroll-top.svg")}})])]),_c('div',{staticClass:"featured-cat-swiper"},[_c('swiper',{ref:'cat_slide_'+_vm.id,attrs:{"slides-per-view":5,"loop":false,"navigation":{
            nextEl: '.arrow-next'+_vm.id,
            prevEl: '.arrow-prev'+_vm.id,
          },"initialSlide":1,"slidesPerGroup":2,"freeMode":false,"spaceBetween":10,"breakpoints":{
            3000: {
              slidesPerView: 5,
              allowTouchMove: false,
            },
            1920: {
              slidesPerView: 5,
              allowTouchMove: false,
            },
            1424: {
              slidesPerView: 5,
              allowTouchMove: false,
            },
            1104: {
              slidesPerView: 4,
              allowTouchMove: false,
            },
            991: {
              slidesPerView: 3,
              allowTouchMove: false,
            },
            800: {
              slidesPerView: 3,
              allowTouchMove: false,
            },
            768: {
              slidesPerView: 3,
              slidesPerGroup: 3,
              allowTouchMove: true,
            },
            550: {
              slidesPerView: 1,
              slidesPerGroup: 1,
              allowTouchMove: true,
            },
            1: {
              slidesPerView: 1,
              slidesPerGroup: 1,
              allowTouchMove: true,
            }
          },"observer":true,"observeParents":true}},_vm._l((_vm.productsData),function(item,index){return _c('swiper-slide',{key:_vm.id +'_'+index+'featured_item'},[_c('div',{staticClass:"featured-cat-slide-item"},[(item.product_family == 'cannabis')?_c('weed-card',{attrs:{"callback":_vm.callback,"item":item}}):_c('accessory-card',{attrs:{"callback":_vm.callback,"item":item}})],1)])}),1)],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }